import { faBan, faBolt, faCameraMovie, faComments, faTrophy, faTrophyStar, faVial } from '@fortawesome/pro-solid-svg-icons';
import { withTranslation } from 'react-i18next';

import defaultPictureAvif from '~/static/default/brickfilm.png?as=avif';
import defaultPicture from '~/static/default/brickfilm.png?as=jpg';
import defaultPictureWebp from '~/static/default/brickfilm.png?as=webp';

import { chooseBestImage, getPictureLink } from '../../../common/resizer';
import Action from '../../Action';
import { faCommentsValidated } from '../../Icons/faCommentsValidated';
import Card from '../Card';
import ContentProgressBar from '../ContentProgressBar';
import CountdownTag from '../CountdownTag';
import Heading from '../Heading';
import Tag from '../Tag';
import TimeTag from '../TimeTag';
import UserTag from '../UserTag';

import * as style from './style.module.css';

const BrickfilmCard = ({ t, id, title, type, slug, runtime, picture, author, maxPlayed, contestRankings, isUnavailable = false, hideAuthor = false, numberOfMessages = null, hasReplied = false, boostEndsAt = null }) => {
  const link = `/brickfilms/${id}/${slug}`;
  const rankingTag = [1, 2, 3]
    .map((position) => ({ position, count: contestRankings?.filter((r) => r.position === position)?.length || 0 }))
    .filter((e) => e.count > 0)
    .map((p) => t('{{count}}_ordinal', { count: p.position, ordinal: true }))
    .join(' / ');
  let bestPosition = Math.min(...(contestRankings?.map((rank) => rank.position).filter((e) => e > 0 && e <= 3) || [])) || null;
  bestPosition = bestPosition === Infinity ? null : bestPosition;

  return (
    <Card disablePadding>
      <Action action={link} title={title}>
        <div className={style.banner}>
          <div className={style.image} style={{ backgroundImage: `url("${chooseBestImage([defaultPicture, defaultPictureWebp, defaultPictureAvif])}")` }} />
          <div className={style.image} style={{ backgroundImage: `url("${getPictureLink(picture, { w: 400 })}")` }} />
          {boostEndsAt && <CountdownTag color="var(--theme-medium-purple)" icon={faBolt}  timestamp={boostEndsAt}/>}
          {!boostEndsAt && type === 'PROJECT' && <Tag icon={faCameraMovie} />}
          {!boostEndsAt && type === 'TEST' && <Tag icon={faVial} />}
          {!boostEndsAt && bestPosition !== null && <Tag className={[style.gold, style.iron, style.bronze][bestPosition - 1]} icon={bestPosition === 1 ? faTrophyStar : faTrophy} tag={rankingTag} />}
          {!boostEndsAt && type !== 'PROJECT' && isUnavailable && <Tag icon={faBan} tag={t('Unavailable')} position="RIGHT" />}
          
          {!isUnavailable && <TimeTag time={runtime} position="RIGHT" />}
          {numberOfMessages !== null && <Tag className={numberOfMessages === 0 ? style.warning : ''} icon={hasReplied ? faCommentsValidated : faComments} tag={numberOfMessages} position="BOTTOM-LEFT" />}
          <ContentProgressBar progress={maxPlayed} />
        </div>
      </Action>
      <div className={style.infos}>
        <Action action={link} title={title}>
          <Heading h={5} oneLine>
            {title}
          </Heading>
        </Action>
        {!hideAuthor && <UserTag {...author} />}
      </div>
      {boostEndsAt && <div className={style.boostedBorder} />}
    </Card>
  );
};

export default withTranslation()(BrickfilmCard);
